import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServiceInterface } from './auth.interface';
import { AUTH_SERVICE } from '@core/auth/token';
import { inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OIDCAuthGuard implements CanActivate {
  private authService = inject<AuthServiceInterface>(AUTH_SERVICE);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    }
    this.authService.login();
    // Not authenticated, redirect to login or homepage
    return false;
  }
}
